import WrapWithDropdownBody from "../WrapWithDropdownBody.vue";
import { SelectedSection } from "../sections";
import TargetingTypeFilterItem from "../items/TargetingTypeFilterItem.vue";
import ListSection from "../sections/ListSection.vue";
export default {
  name: "TargetingTypeFilterBody",
  components: {
    WrapWithDropdownBody,
    SelectedSection,
    TargetingTypeFilterItem,
    ListSection
  },
  emits: ["clear", "discard", "restoreSearch", "select", "selectOnly", "deselect", "apply", "search", "hidden", "closeDropdown"],
  props: {
    title: {
      type: String,
      default: "Targeting Type"
    },
    selected: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    isModified: {
      type: Boolean,
      default: false
    },
    // Filter.pendingChanges: { count, text } | string | null
    pendingChanges: {
      type: [Object, String],
      default: null
    },
    searching: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: [String, Array],
      default: ""
    }
  }
};